module.exports = __webpack_public_path__ + "img/Branches.49f34687.svg";